import { BreadcrumbsViewModel } from '../breadcrumbs-view-model/breadcrumbsViewModel';

export class BreadcrumbsViewModelBuilder {
  viewModel: BreadcrumbsViewModel = {
    homeUrl: 'https://example.com',
    serviceListUrl: 'https://example.com/services',
    serviceName: 'Test Service',
  };

  withHomeUrl(homeUrl: string) {
    this.viewModel.homeUrl = homeUrl;
    return this;
  }

  withServiceListUrl(serviceListUrl: string) {
    this.viewModel.serviceListUrl = serviceListUrl;
    return this;
  }

  withServiceName(serviceName: string) {
    this.viewModel.serviceName = serviceName;
    return this;
  }

  build(): BreadcrumbsViewModel {
    return this.viewModel;
  }
}
